import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import ActorCard from '../components/ActorCard';
import SkeletonCard from '../components/ui/SkeletonCard';
import { getMovieRequest } from '../api/api';

const Popular = () => {
  const navigate = useNavigate();
  const [actors, setActors] = useState(null);

  const loadActors = useCallback(async (signal) => {
    const data = await getMovieRequest();
    if (signal?.aborted) return;
    if (data) setActors(data.results);
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    loadActors(controller.signal);
    return () => controller.abort();
  }, [loadActors]);

  return (
    <div className="min-h-screen bg-[#fdf6ec] px-4 py-8">
      <div className="max-w-sm mx-auto">

        <div className="flex items-center justify-between mb-6">
          <div>
            <span className="bg-[#ff6b35] text-white text-xs font-black tracking-[3px] uppercase px-3 py-1 rounded">
              FILMQUEST
            </span>
            <h1 className="text-2xl font-black text-[#1a1a1a] mt-2">Popular Actors</h1>
          </div>
          <button
            onClick={() => navigate('/')}
            className="bg-white text-[#1a1a1a] font-black text-sm py-2 px-4 rounded-lg border-[3px] border-[#1a1a1a] shadow-[3px_3px_0_#1a1a1a] hover:shadow-[1px_1px_0_#1a1a1a] transition-shadow"
          >
            ← Back
          </button>
        </div>

        <div className="flex flex-col gap-3">
          {actors
            ? actors.map(actor => (
                <ActorCard
                  key={actor.id}
                  actorId={actor.id}
                  actorName={actor.name}
                  actorRole={actor.known_for_department}
                  actorImgUrl={actor.profile_path}
                />
              ))
            : Array.from({ length: 6 }).map((_, i) => <SkeletonCard key={i} />)
          }
        </div>

      </div>
    </div>
  );
};

export default Popular;
